import * as React from "react";
import { NavLink } from "react-router-dom";
import { withTranslation } from "react-i18next";
import UserModal from "../components/UserModal";
import CoreComponent from "./CoreComponent";
import PasswordModal from "../components/PasswordModal";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import { arrayToFormData } from "../utils/functions";
import { toast } from "react-toastify";
import { USER_LOGIN } from "../reducers/auth";
import { connect } from "react-redux";
import MoveSettingModal from "../components/MoveSettingModal";

interface IState {
    isOpen: boolean,
    isPasswordOpen: boolean,
    isMoveSettingOpen: boolean,
    fileInput: any,
    file: any
}

class Settings extends CoreComponent<any, IState> {
    state: IState = {
        isOpen: false,
        isPasswordOpen: false,
        isMoveSettingOpen: false,
        fileInput: null,
        file: null
    }

    constructor(props: any) {
        super(props);

        this.handleModal = this.handleModal.bind(this);
        this.handlePasswordModal = this.handlePasswordModal.bind(this);
        this.handleMoveSettingModal = this.handleMoveSettingModal.bind(this);
    }

    handleModal() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    handlePasswordModal() {
        this.setState({
            isPasswordOpen: !this.state.isPasswordOpen
        });
    }

    handleMoveSettingModal() {
        this.setState({
            isMoveSettingOpen: !this.state.isMoveSettingOpen
        });
    }

    async upload() {
        let res: AxiosResponse = await Axios.post(`${config.api}/staff/change-avatar`, arrayToFormData({
            file: this.state.file
        }));

        if (res.data.status == "success") {
            toast("Аватар успешно изменён.", { type: "success" });

            let user = JSON.parse(localStorage.getItem("user"));
            user.image = res.data.url;

            localStorage.setItem('user', JSON.stringify(user));

            this.props.dispatch({
                type: USER_LOGIN,
                user,
            });
        }

    }

    render() {
        return (
            <div className="crm-menu">
                <UserModal isOpen={this.state.isOpen} handleModal={this.handleModal} />
                <PasswordModal isOpen={this.state.isPasswordOpen} handleModal={this.handlePasswordModal} />
                <MoveSettingModal isOpen={this.state.isMoveSettingOpen} handleModal={this.handleMoveSettingModal} />

                <div className="wrapper">
                    <NavLink className="crm-holders__back" to="/admin">
                        Назад
                    </NavLink>
                    <span className="crm-holders__title">Настройки</span>
                    <input type="file" style={{ display: "none" }} ref={ref => this.state.fileInput = ref} accept=".png, .jpg, .jpeg" name="logo" onChange={(e: any) => {
                        this.setState({
                            file: e.target.files.length > 0 ? e.target.files[0] : null
                        }, () => {
                            this.upload();
                        });
                    }} />
                    <div className="crm-settings">
                        <a role="button" onClick={() => {
                            this.handleMoveSettingModal();
                        }}>Изменить курс и коммент.</a>
                        <a role="button" onClick={() => {
                            this.handlePasswordModal();
                        }}>Изменить пароль</a>
                        <a role="button" onClick={() => {
                            this.state.fileInput.click();
                        }}>Загрузить аватар</a>
                        <a role="button" onClick={() => {
                            this.handleModal();
                        }}>Добавить пользователя</a>
                        <NavLink to="/admin/archive/holders">Архивированные партнеры</NavLink>
                        <NavLink to="/admin/archive/objects">Архивированные объекты</NavLink>

                    </div>
                </div>
            </div>
        );
    }
}

export default connect()(withTranslation()(Settings));
